<template>
  <div class="app-version p-10">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button type="primary" size="medium" @click.native="() => edit()">新增</el-button>
      </div>
      <!-- <div class="search-group">
        <el-input placeholder="标题关键词" v-model.trim="searchFormData.title" @keypress.enter.native="search" />
        <el-button type="primary" size="medium" @click="search">查询</el-button>
      </div> -->
    </div>
    <div class="ly-card">
      <ly-table :getTableData="getTableData" :tableHeader="tableHeader" :searchFormData="searchFormData" ref="lyTable">
        <template v-slot:download_url="row">
          <a
            v-if="row.download_url"
            class="el-button el-button--text el-button--mini"
            :href="`${baseUrl}/${row.download_url}`"
            target="_blank"
            >{{ row.download_url.split('/').slice(-1)[0] }}</a
          >
          <span v-else></span>
        </template>
        <template v-slot:pkg_size="row">
          {{ row.pkg_size | pkgSize }}
        </template>

        <template v-slot:action="row">
          <template v-if="!row.version_status">
            <el-button @click="edit(row)" type="text" size="mini">修改</el-button>
            <el-button @click="push(row)" type="text" class="el-button--danger" size="mini">发布</el-button>
            <el-button @click="del(row)" type="text" class="el-button--danger" size="mini">删除</el-button>
          </template>
          <span v-else>一</span>
        </template>
      </ly-table>
    </div>
    <el-dialog :title="`${defaultFormItem.id ? '编辑' : '新增'}版本`" :visible.sync="dialogVisible" width="600px">
      <ly-form :formConfig="formConfig" :defaultFormItem="defaultFormItem" :formKeys="formKeys" ref="lyForm">
        <template v-slot:download_url="{ formData }">
          <upload
            ButtonText="包上传"
            :params="uploadParams"
            @successCBK="value => (formData.download_url = value)"
            :before="before"
            accept=".apk"
          />
          {{ Array.isArray(formData.download_url) ? formData.download_url[0].url : formData.download_url }}
        </template>
      </ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui';
import { frontInf } from '@/api';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { appVersionItem } from '@/utils/formConfig';
import { appVersionTable } from '@/utils/tableHeader';
import Upload from '@/components/Upload';

export default {
  name: 'ApplicationVersion',
  components: {
    LyTable,
    LyForm,
    Upload,
    ElDialog: Dialog
  },
  data() {
    return {
      searchFormData: {
        title: ''
      },
      defaultFormItem: {},
      tableHeader: appVersionTable,
      getTableData: frontInf.getVersion,
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        inline: false,
        itemSpan: 24
      },
      formKeys: {},
      dialogVisible: false,
      pkg_size: 0,
      uploadParams: {},
      baseUrl: ''
    };
  },
  async mounted() {
    this.init();
    this.baseUrl = await this.$store.dispatch('app/getOssUrl');
  },
  filters: {
    pkgSize(value) {
      if (value < 1024) return `${value}B`;
      if (value < 1024 * 1024) return `${(value / 1024).toFixed(2)}kb`;
      return `${(value / (1024 * 1024)).toFixed(2)}MB`;
    }
  },
  methods: {
    async init() {
      frontInf.appType().then(res => {
        if (res) {
          appVersionItem.app_type.options.select = res.data;
        }
        this.formKeys = appVersionItem;
      });
      this.search();
    },
    search() {
      this.$refs.lyTable.setData();
    },
    close() {
      this.defaultFormItem = {};
      this.dialogVisible = false;
    },
    before(file) {
      this.pkg_size = file.size;
      this.uploadParams = {
        filename: `${file.name}`
      };
      return !!file.size;
    },
    edit(row) {
      this.defaultFormItem = { ...row };
      this.dialogVisible = true;
    },
    submit() {
      this.$refs.lyForm.getFormData().then(async ({ valid, data }) => {
        if (valid) {
          let res = null;
          const temp = { ...data };
          if (Array.isArray(temp.download_url)) {
            temp.download_url = temp.download_url[0].url;
          } else {
            delete temp.download_url;
          }
          if (this.defaultFormItem.id) {
            res = await frontInf.controlVersion({
              version_id: this.defaultFormItem.id,
              params: {
                ...temp,
                pkg_size: this.pkg_size
              },
              methold: 'put'
            });
          } else {
            res = await frontInf.addVersion({
              params: {
                ...temp,
                pkg_size: this.pkg_size
              }
            });
          }
          if (res) {
            this.$message.success(res.msg || '操作成功');
            this.defaultFormItem = {};
            this.pkg_size = 0;
            this.dialogVisible = false;
            this.search();
          }
        }
      });
    },
    del(row) {
      this.$confirm('永久删除该版本信息, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          frontInf
            .controlVersion({
              version_id: row.id,
              methold: 'DELETE'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    push(row) {
      this.$confirm(`发布该版本${row.app_type_label}(${row.version_number}), 是否继续?`, '警告', {
        type: 'warning'
      })
        .then(() => {
          frontInf
            .versionPublish({
              version_id: row.id,
              app_type: row.app_type
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '发布成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less">
.app-version {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
}
</style>
